/**
 * Which pages drop parts of the app chrome for a marketing layout.
 *
 * Kept in one place so a new marketing page is a single edit rather than the
 * handful of `router.pathname === '/'` checks it used to be (DEV-6878).
 */

/**
 * The API landing page is served at /api through a rewrite (next.config.ts),
 * since `pages/api` is reserved for API routes. `router.pathname` is this.
 */
export const API_PAGE_PATHNAME = '/uppbeat-api';

/**
 * Pages that use the homepage's navigation treatment: a floating Uppbeat logo,
 * library links in the top bar, and no global search.
 */
export const usesHomepageNav = (pathname: string) =>
  pathname === '/' || pathname === '/about' || pathname === API_PAGE_PATHNAME;

/** Pages that render without the left sidebar. */
export const hidesSidebar = (pathname: string) =>
  usesHomepageNav(pathname) || pathname.startsWith('/pricing');

/**
 * Pages whose top bar is solid from the start, following the theme, so the
 * library links show before the visitor scrolls.
 */
export const usesSolidChrome = (pathname: string) =>
  pathname === API_PAGE_PATHNAME;

/**
 * Pages whose top bar always sits on dark content, whatever the visitor's
 * theme — so it keeps the dark treatment rather than following the theme.
 */
export const usesDarkChrome = (pathname: string) => pathname === '/about';
